import { render } from "./GameRules.vue?vue&type=template&id=109e4f3a&scoped=true"
import script from "./GameRules.vue?vue&type=script&lang=js"
export * from "./GameRules.vue?vue&type=script&lang=js"

import "./GameRules.vue?vue&type=style&index=0&id=109e4f3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109e4f3a"]])

export default __exports__